import LoadingOverlay from './LoadingOverlay';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';

const USER_ACTIVITY_QUERY = gql`
  query StatsUserActivity {
    userActivity: stats_user_activity {
      userId: user_id
      firstName: first_name
      lastName: last_name
      welding30: welding_30
      inspection30: inspection_30
      revision30: revision_30
      wps30: wps_30
    }
  }
`;

class UserActivityChart extends Component {
  render() {
    return (
      <Query query={USER_ACTIVITY_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>User Log Activity - Top 10 (last 30 days)</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '150px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && (
                <Table size="sm" responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th className="text-center">Welding</th>
                      <th className="text-center">Inspection</th>
                      <th className="text-center">Revision</th>
                      <th className="text-center">WPS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.userActivity.map((user, idx) => (
                      <tr key={idx}>
                        <td>{user.firstName} {user.lastName}</td>
                        <td className="text-center">{user.welding30}</td>
                        <td className="text-center">{user.inspection30}</td>
                        <td className="text-center">{user.revision30}</td>
                        <td className="text-center">{user.wps30}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default UserActivityChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/UserActivityChart.js